import UserTransactionsHistory from './UserTransactionsHistory';

export default UserTransactionsHistory;
